export default __webpack_public_path__ + "static/media/team75.884fb0c1.JPG";